
      import RegionFilled from './region-filled.vue'
      import type { App, Plugin } from 'vue'

      export const RegionFilledPlugin: Plugin = {
        install(app: App) {
          app.component('RegionFilled', RegionFilled)
        },
      }
      export { RegionFilled }
      